import React from 'react';
import { Link } from 'react-router-dom';

import { useLoggedInStatus } from '../../../hooks';
import { RouteDictionary } from '../../../utils';
import { CustomLink, Image } from '../../common';
import { LogoImage } from '../../common/images/types';
import { LogoType } from '../../common/images/types/LogoImage';
import { useWindowWidth } from '../../pages/detailed-project/hooks';
import { ProfileMenu } from '../../user';
import { Container } from '../index';
import styles from './HeaderNew.module.scss';

export const HeaderPublic = () => {
  const isLoggedIn = useLoggedInStatus();
  const isMobile = useWindowWidth();
  return (
    <header className={styles.header}>
      <Container>
        <div className={styles.logo__container}>
          <CustomLink to={RouteDictionary.INDEX}>
            <LogoImage className={styles.logo} type={isMobile ? LogoType.CONE : LogoType.HEADER} />
          </CustomLink>
          <div className={styles.nav__right__public}>
            {!isLoggedIn ? (
              <div className={styles.public}>
                <CustomLink to={RouteDictionary.HOW_IT_WORKS} className={styles.howItWorks}>
                  Как это работает
                </CustomLink>
                <Link to={RouteDictionary.ENTER} className={styles.public__button}>
                  Личный кабинет
                </Link>
              </div>
            ) : (
              <div className={styles.user__menu}>
                <ProfileMenu />
              </div>
            )}
          </div>
        </div>
      </Container>
    </header>
  );
};
